module.exports = __webpack_public_path__ + "static/media/background2.0f6087b9.webp";